import { render, staticRenderFns } from "./RiskCalculation.vue?vue&type=template&id=359d0911&scoped=true"
import script from "./RiskCalculation.vue?vue&type=script&lang=js"
export * from "./RiskCalculation.vue?vue&type=script&lang=js"
import style0 from "./RiskCalculation.vue?vue&type=style&index=0&id=359d0911&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359d0911",
  null
  
)

export default component.exports